var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot2Vector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 35,
    viewBox: "0 0 68 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7188 17.6574C46.7188 16.1244 47.9614 14.8817 49.4944 14.8817C51.0273 14.8817 52.27 16.1244 52.27 17.6574C52.27 19.1904 51.0273 20.4331 49.4944 20.4331C47.9614 20.4331 46.7188 19.1904 46.7188 17.6574Z",
    fill: "url(#paint0_linear_451_288)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2954 17.6574C62.2954 16.1244 63.5381 14.8817 65.071 14.8817C66.6039 14.8817 67.8466 16.1244 67.8466 17.6574C67.8466 19.1904 66.6039 20.4331 65.071 20.4331C63.5381 20.4331 62.2954 19.1904 62.2954 17.6574Z",
    fill: "url(#paint1_linear_451_288)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1421 3.03482C31.1421 1.50183 32.3848 0.259097 33.9177 0.259097C35.4506 0.259097 36.6933 1.50183 36.6933 3.03482C36.6933 4.56781 35.4506 5.81055 33.9177 5.81055C32.3848 5.81055 31.1421 4.56781 31.1421 3.03482Z",
    fill: "url(#paint2_linear_451_288)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7188 3.03482C46.7188 1.50183 47.9614 0.259097 49.4944 0.259097C51.0273 0.259097 52.27 1.50183 52.27 3.03482C52.27 4.56781 51.0273 5.81055 49.4944 5.81055C47.9614 5.81055 46.7188 4.56781 46.7188 3.03482Z",
    fill: "url(#paint3_linear_451_288)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2954 3.03482C62.2954 1.50183 63.5381 0.259097 65.071 0.259097C66.6039 0.259097 67.8466 1.50183 67.8466 3.03482C67.8466 4.56781 66.6039 5.81055 65.071 5.81055C63.5381 5.81055 62.2954 4.56781 62.2954 3.03482Z",
    fill: "url(#paint4_linear_451_288)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1421 32.2243C31.1421 30.6913 32.3848 29.4485 33.9177 29.4485C35.4506 29.4485 36.6933 30.6913 36.6933 32.2243C36.6933 33.7573 35.4506 35 33.9177 35C32.3848 35 31.1421 33.7573 31.1421 32.2243Z",
    fill: "url(#paint5_linear_451_288)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7188 32.2243C46.7188 30.6913 47.9614 29.4485 49.4944 29.4485C51.0273 29.4485 52.27 30.6913 52.27 32.2243C52.27 33.7573 51.0273 35 49.4944 35C47.9614 35 46.7188 33.7573 46.7188 32.2243Z",
    fill: "url(#paint6_linear_451_288)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2954 32.2243C62.2954 30.6913 63.5381 29.4485 65.071 29.4485C66.6039 29.4485 67.8466 30.6913 67.8466 32.2243C67.8466 33.7573 66.6039 35 65.071 35C63.5381 35 62.2954 33.7573 62.2954 32.2243Z",
    fill: "url(#paint7_linear_451_288)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.52588e-05 17.6574C-1.52588e-05 16.1244 1.24266 14.8817 2.77558 14.8817C4.3085 14.8817 5.55118 16.1244 5.55118 17.6574C5.55118 19.1904 4.3085 20.4331 2.77558 20.4331C1.24266 20.4331 -1.52588e-05 19.1904 -1.52588e-05 17.6574Z",
    fill: "url(#paint8_linear_451_288)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5654 17.6574C15.5654 16.1244 16.8081 14.8817 18.341 14.8817C19.874 14.8817 21.1166 16.1244 21.1166 17.6574C21.1166 19.1904 19.874 20.4331 18.341 20.4331C16.8081 20.4331 15.5654 19.1904 15.5654 17.6574Z",
    fill: "url(#paint9_linear_451_288)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1421 17.6574C31.1421 16.1244 32.3848 14.8817 33.9177 14.8817C35.4506 14.8817 36.6933 16.1244 36.6933 17.6574C36.6933 19.1904 35.4506 20.4331 33.9177 20.4331C32.3848 20.4331 31.1421 19.1904 31.1421 17.6574Z",
    fill: "url(#paint10_linear_451_288)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.52588e-05 3.03482C-1.52588e-05 1.50183 1.24266 0.259097 2.77558 0.259097C4.3085 0.259097 5.55118 1.50183 5.55118 3.03482C5.55118 4.56781 4.3085 5.81055 2.77558 5.81055C1.24266 5.81055 -1.52588e-05 4.56781 -1.52588e-05 3.03482Z",
    fill: "url(#paint11_linear_451_288)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5654 3.03482C15.5654 1.50183 16.8081 0.259097 18.341 0.259097C19.874 0.259097 21.1166 1.50183 21.1166 3.03482C21.1166 4.56781 19.874 5.81055 18.341 5.81055C16.8081 5.81055 15.5654 4.56781 15.5654 3.03482Z",
    fill: "url(#paint12_linear_451_288)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.52588e-05 32.2243C-1.52588e-05 30.6913 1.24266 29.4485 2.77558 29.4485C4.3085 29.4485 5.55118 30.6913 5.55118 32.2243C5.55118 33.7573 4.3085 35 2.77558 35C1.24266 35 -1.52588e-05 33.7573 -1.52588e-05 32.2243Z",
    fill: "url(#paint13_linear_451_288)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5654 32.2243C15.5654 30.6913 16.8081 29.4485 18.341 29.4485C19.874 29.4485 21.1166 30.6913 21.1166 32.2243C21.1166 33.7573 19.874 35 18.341 35C16.8081 35 15.5654 33.7573 15.5654 32.2243Z",
    fill: "url(#paint14_linear_451_288)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_451_288",
    x1: 51.2522,
    y1: 20.4331,
    x2: 48.6615,
    y2: 15.4369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_451_288",
    x1: 66.8289,
    y1: 20.4331,
    x2: 64.2382,
    y2: 15.4369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_451_288",
    x1: 35.6756,
    y1: 5.81055,
    x2: 33.0848,
    y2: 0.81434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_451_288",
    x1: 51.2522,
    y1: 5.81055,
    x2: 48.6615,
    y2: 0.81434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_451_288",
    x1: 66.8289,
    y1: 5.81055,
    x2: 64.2382,
    y2: 0.81434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_451_288",
    x1: 35.6756,
    y1: 35,
    x2: 33.0848,
    y2: 30.0038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_451_288",
    x1: 51.2522,
    y1: 35,
    x2: 48.6615,
    y2: 30.0038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_451_288",
    x1: 66.8289,
    y1: 35,
    x2: 64.2382,
    y2: 30.0038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_451_288",
    x1: 4.53346,
    y1: 20.4331,
    x2: 1.94271,
    y2: 15.4369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_451_288",
    x1: 20.0989,
    y1: 20.4331,
    x2: 17.5082,
    y2: 15.4369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_451_288",
    x1: 35.6756,
    y1: 20.4331,
    x2: 33.0848,
    y2: 15.4369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_451_288",
    x1: 4.53346,
    y1: 5.81055,
    x2: 1.94271,
    y2: 0.81434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_451_288",
    x1: 20.0989,
    y1: 5.81055,
    x2: 17.5082,
    y2: 0.81434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_451_288",
    x1: 4.53346,
    y1: 35,
    x2: 1.94271,
    y2: 30.0038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_451_288",
    x1: 20.0989,
    y1: 35,
    x2: 17.5082,
    y2: 30.0038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot2Vector);
export default __webpack_public_path__ + "static/media/dot2-vector.269fcae642be29d8dc5526ee1992b26d.svg";
export { ForwardRef as ReactComponent };